import first from 'lodash/first';
import React, { PropsWithChildren, useContext, useEffect } from 'react';

import { IntegrationSystem } from '@/shared/types';
import { ConditionView } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { FeatureName } from '@/api/types';

import { die, on, EventUpdateData } from '../../eventBus';
import AuthContext from '../Auth/AuthContext';

import { FeatureContext } from './FeatureContext';
import { useFeatureManagement } from './userFeaturesManagement';

const getSourceSystemByFeature = (key: FeatureName): IntegrationSystem => {
  const system = first(key?.split('.')) || '';
  const prefix = '_services';

  return (system.replace(prefix, '') as IntegrationSystem) || null;
};

export const FeatureProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoggedIn } = useContext(AuthContext);
  const { isLoading, hasBeenFetched, isFeatureAvailable, refetch, getDetails } = useFeatureManagement(isLoggedIn);

  const showLoader: boolean = isLoading && !hasBeenFetched;

  useEffect(() => {
    on('update_features', ({ force = false }: EventUpdateData) => {
      if (force) refetch();
    });

    return () => {
      die('update_features');
    };
  }, [refetch]);

  return (
    <FeatureContext.Provider
      value={{
        isFeatureAvailable,
        getFeatureDetails: getDetails as any,
        getSourceSystemByFeature,
      }}
    >
      <ConditionView if={showLoader}>
        <Loader centered />
      </ConditionView>

      <div id="feature-provider-container" style={{ display: showLoader ? 'none' : 'block' }}>
        {children}
      </div>
    </FeatureContext.Provider>
  );
};
